import { render } from "./Pokemon.vue?vue&type=template&id=726a4630&scoped=true"
import script from "./Pokemon.vue?vue&type=script&lang=js"
export * from "./Pokemon.vue?vue&type=script&lang=js"

import "./Pokemon.vue?vue&type=style&index=0&id=726a4630&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726a4630"]])

export default __exports__